export default "__VITE_ASSET__a9c45b00__"